export default __webpack_public_path__ + "static/media/D026.7aeb49ef.jpg";